export default __webpack_public_path__ + "static/media/twitter.224fa816.svg";